module.exports = __webpack_public_path__ + "static/media/icono_dj.28be59f2.svg";